import React, { cloneElement } from 'react';
import { BookOpen, Beaker, Scale, ListOrdered, ShoppingCart, Truck, FileText, CheckSquare, Printer, RefreshCw, Package } from 'lucide-react';
export function WhatsIncluded() {
  const features = [{
    icon: <BookOpen size={32} data-id="element-221" />,
    text: 'Más de 25 fórmulas de productos de limpieza'
  }, {
    icon: <Beaker size={32} data-id="element-222" />,
    text: 'Versiones económicas y premium'
  }, {
    icon: <Scale size={32} data-id="element-223" />,
    text: 'Ingredientes y proporciones exactas'
  }, {
    icon: <ListOrdered size={32} data-id="element-224" />,
    text: 'Explicaciones paso a paso'
  }, {
    icon: <ShoppingCart size={32} data-id="element-225" />,
    text: 'Guía de materias primas'
  }, {
    icon: <Truck size={32} data-id="element-226" />,
    text: 'Lista de proveedores'
  }, {
    icon: <FileText size={32} data-id="element-227" />,
    text: 'Procedimientos simplificados'
  }, {
    icon: <CheckSquare size={32} data-id="element-228" />,
    text: 'Fórmulas listas para producir'
  }, {
    icon: <Printer size={32} data-id="element-229" />,
    text: 'Material imprimible'
  }, {
    icon: <RefreshCw size={32} data-id="element-230" />,
    text: 'Actualizaciones futuras incluidas'
  }];
  const products = ['Jabón líquido', 'Detergentes líquidos', 'Suavizantes', 'Limpia pisos', 'Blanqueadores', 'Limpiadores para ropa color', 'Quitamanchas', 'Jabón en barra', 'Jabón antibacterial', 'Perfume para ropa', 'Pastillas para inodoros', 'Limpia vidrios', 'Limpiador para grifería', 'Toallitas desinfectantes', 'Desinfectante de alfombras', 'Limpiador de pantallas', 'Desengrasantes', 'Limpia pisos desinfectante', 'Cera para pisos', 'Sellador para pisos', 'Shampoo para vehículos', 'Abrillantador de neumáticos', 'Silicona líquida'];
  return <section className="py-8 md:py-16 px-4 bg-dark-800 border-y border-dark-700" data-id="element-231">
      <div className="max-w-6xl mx-auto" data-id="element-232">
        <div className="text-center mb-8 md:mb-12" data-id="element-233">
          <h2 className="text-xl md:text-5xl font-black text-white mb-3 md:mb-4 uppercase leading-snug" data-id="element-234">
            📘 ¿QUÉ INCLUYE EL <span className="text-brand-400" data-id="element-235">SISTEMA?</span>
          </h2>
          <p className="text-sm md:text-xl text-gray-400 font-medium max-w-2xl mx-auto leading-relaxed" data-id="element-236">
            Accedé al sistema completo que organiza todo el proceso en un solo
            lugar.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-6 mb-16" data-id="element-237">
          {features.map((feature, i) => <div key={i} className="bg-dark-900 p-4 md:p-6 rounded-xl shadow-md border border-dark-700 flex flex-col items-center text-center hover:-translate-y-1 hover:shadow-lg hover:border-brand-500/50 transition-all duration-300" data-id="element-238">
              <div className="bg-brand-500/10 text-brand-400 p-3 md:p-4 rounded-full mb-3 md:mb-4" data-id="element-239">
                {cloneElement(feature.icon, {
              className: 'w-6 h-6 md:w-8 md:h-8'
            })}
              </div>
              <h3 className="font-bold text-sm md:text-base text-gray-200 leading-tight" data-id="element-240">
                {feature.text}
              </h3>
            </div>)}
        </div>

        <div className="bg-dark-900 rounded-3xl p-6 md:p-10 border border-dark-700 shadow-xl" data-id="element-241">
          <div className="text-center mb-8" data-id="element-242">
            <div className="inline-flex items-center justify-center p-3 bg-brand-500/10 rounded-full mb-4" data-id="element-243">
              <Package size={32} className="text-brand-400" data-id="element-244" />
            </div>
            <h3 className="text-xl md:text-3xl font-black text-white uppercase" data-id="element-245">
              📦 PRODUCTOS QUE APRENDERÁS A FABRICAR
            </h3>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4" data-id="element-246">
            {products.map((product, i) => <div key={i} className="flex items-center gap-2 text-gray-300" data-id="element-247">
                <div className="w-1.5 h-1.5 rounded-full bg-brand-500 shrink-0" data-id="element-248"></div>
                <span className="font-medium text-sm md:text-base" data-id="element-249">
                  {product}
                </span>
              </div>)}
            <div className="flex items-center gap-2 text-brand-400 font-bold col-span-full mt-2" data-id="element-250">
              <div className="w-1.5 h-1.5 rounded-full bg-brand-500 shrink-0" data-id="element-251"></div>
              <span className="text-sm md:text-base" data-id="element-252">
                Y muchas fórmulas complementarias adicionales...
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}